module.exports = __webpack_public_path__ + "img/altitude-resort-4.fe41a4af.jpg";